import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-12v3',
  templateUrl: './12v3.component.html',
})
export class VbGeneral12v3Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
